import type { SearchResult } from '../../../../common/types';

const SearchResultTalentPosition = `
... on SearchResultTalentPosition {     
	__typename
	lastModifiedDate
	position {
		__typename
		worker {
			preferredName
			user {
				picture
			}
		}
		fieldValues(
			fieldIdIsIn: [
				"positionId", 
				"positionStatus", 
				"positionJobTitle", 
				"positionPositionTitle", 
				"positionKey", 
				"positionExternalPositionKey", 
				"positionPositionlabel", 
				"positionWorker"
			]
		) {
			fieldId
			fieldValue {
				__typename
				... on RadarStringFieldValue {
					__typename
					stringValue: value
				}
			}
		}
	}
}
`;

export interface SearchResultTalentPosition extends SearchResult {
	lastModifiedDate: string;
	position?: {
		fieldValues: Array<{
			fieldId: string;
			fieldValue: {
				stringValue: string;
			};
		}>;
		worker: {
			preferredName?: string;
			user: {
				picture: string;
			};
		};
	};
	__typename: 'SearchResultTalentPosition';
}

export type SearchTalentPartial = SearchResultTalentPosition;

export const isSearchResultTalentPositionPartial = (
	partial: SearchResult,
): partial is SearchResultTalentPosition => {
	return partial?.id?.includes('radar') && partial.__typename === 'SearchResultTalentPosition';
};

export const isSearchTalentPartial = (partial: SearchResult): partial is SearchTalentPartial => {
	return isSearchResultTalentPositionPartial(partial);
};

export const getTalentPartials = () => {
	return `
		${SearchResultTalentPosition}
	`;
};
